import React, { useState } from 'react';
import { Alert } from 'antd';
import { useTranslate } from '@tolgee/react';
import { IAbandonedBusinessTokenData } from '../../interfaces/abandoned-business/IAbandonedBusinessTokenData';
import { IAbandonedBusinessDishSelectionHook } from '../../interfaces/abandoned-business/IAbandonedBusinessDishSelection';
import AbandonedBusinessGreeting from './AbandonedBusinessGreeting';
import DishSelectionList from './DishSelectionList';
import DeclineForm from './DeclineForm';
import AbandonedBusinessActions from './AbandonedBusinessActions';

type Props = {
  data: IAbandonedBusinessTokenData;
  dishSelection: IAbandonedBusinessDishSelectionHook;
  onSubmit: () => void;
  isSubmitting: boolean;
  submitError?: string;
};

const AbandonedBusinessContent: React.FC<Props> = ({
  data,
  dishSelection,
  onSubmit,
  isSubmitting,
  submitError,
}) => {
  const { t } = useTranslate();
  const {
    selection,
    toggleDish,
    updateQuantity,
    setDidNotTakeAnything,
    setComment,
    canSubmit,
  } = dishSelection;

  const [isDeclineMode, setIsDeclineMode] = useState(false);

  const handleToggleDecline = () => {
    const next = !isDeclineMode;
    setIsDeclineMode(next);
    setDidNotTakeAnything(next);
  };

  return (
    <>
      <AbandonedBusinessGreeting
        userName={data?.userName || ''}
        firstName={data?.firstName || ''}
        fridgeName={data?.fridgeName || ''}
        openedAt={data?.openedAt || ''}
      />
      {submitError && (
        <Alert
          type='error'
          message={t(submitError)}
          showIcon
          style={{ marginBottom: 16, borderRadius: 10 }}
        />
      )}
      {isDeclineMode ? (
        <DeclineForm comment={selection.comment} onCommentChange={setComment} />
      ) : (
        <DishSelectionList
          dishes={data?.availableDishes || []}
          selectedDishes={selection.selectedDishes}
          onToggle={toggleDish}
          onQuantityChange={updateQuantity}
        />
      )}
      <AbandonedBusinessActions
        isDeclineMode={isDeclineMode}
        canSubmit={canSubmit}
        isSubmitting={isSubmitting}
        itemCount={selection.selectedDishes.reduce((s, d) => s + d.quantity, 0)}
        onSubmit={onSubmit}
        onToggleDecline={handleToggleDecline}
      />
    </>
  );
};

export default AbandonedBusinessContent;
